import { BREAKPOINTS } from "@ubnt/store.core/lib/constants/layout";
import Questions, {
  Body,
  FaqQue,
} from "pages/LayoutComponents/Questions/Questions";
import styled from "styled-components";

export const StyledQuestions = styled(Questions)`
  ${Body} {
    padding: 40px 0 0;

    @media ${BREAKPOINTS.TABLET_AND_DOWN} {
      padding: 16px 0 0;
    }
  }

  ${FaqQue} {
    padding: 18px 0;

    @media ${BREAKPOINTS.TABLET_AND_DOWN} {
      font-size: 16px;
    }
  }
`;
